import {sameAs, required, numeric, requiredIf, email, minLength, maxLength, requiredUnless, decimal} from 'vuelidate/lib/validators'
import maxDateValue from '@/components/validations/maxDateValue'
import minDateValue from '@/components/validations/minDateValue'
import dateDiffLessThan from '@/components/validations/dateDiffLessThan'
import requireCheckedIf from '@/components/validations/requireCheckedIf'
import errorIfChecked from '@/components/validations/errorIfChecked'
import timeLessThan from '@/components/validations/timeLessThan'
import timeGreaterThan from '@/components/validations/timeGreaterThan'
import lessThan from '@/components/validations/lessThan'
import moment from 'moment'
import {addWeekdays} from '@/js/FormFunctions'
import maxFileSize from '../components/validations/maxFileSize';
import isWholeNumber from '../components/validations/isWholeNumber';
import iepaRequired from './iepaRequired'



export class DDDValidation {
  materials = {
    receiptFile: required,
    isValid: function () {
      var result = true

      this.form.materials.forEach((material) => {
        if (!material.quantityActual || (material.linktoRecyclingFacility == null || +material.linktoRecyclingFacility <= 0) || (!material.materialType || material.materialType.length == 0)) {
          result = false
        }
      })
      return result;
    },

    estimateValid: function () {
      let sum = 0;
      let res = true;
      this.form.materials.forEach((material) => {
        sum += +material.quanityActual
      })

      if (this.form.materialActual <= 0) {
        return false;
      }

      if (this.form.exempt == false) {
        if (((sum / this.form.quanityActual) * 100) < 70 || sum > this.form.materialActual) {
          res = false;
        }
      }
      return res;
    }

  }
}

export class PermitApplicationValidation {
  // constructor () {
  //   this.facility.constructionYear = {
  //     required: requiredIf(function () {
  //       return this.form.projectType.toLowerCase() === 'demolition'
  //     }),
  //     between: between(1500, (new Date().getFullYear()) + 1)
  //   }
  // }

  contactEmail = {required, email}
  confirmEmail = {
    required,
    sameAs: sameAs('contactEmail'),
    email
  }
  materials = {
    isValid: function () {
      //iterate over materials and do individal validations
      var result = true

      if (this.form.projectType.toLowerCase() === 'asbestos' || this.form.exempt === true) {
        return true;
      }

      this.form.materials.forEach((material) => {
        if (!material.quantityEstimate ||
           (material.linktoRecyclingFacility == null ||
           +material.linktoRecyclingFacility <= 0) ||
          (!material.materialType || material.materialType.length == 0) ||
          (material.materialType == "Other" && (!material.overrideName || material.overrideName.length == 0))) {
          result = false
        }
      })
      return result;
    },
    estimateValid: function () {
      let sum = 0;
      let res = true;
      if (this.form.projectType.toLowerCase() === 'asbestos' || this.form.exempt === true) {
        return true;
      }

      if (this.form.materialEstimate <= 0) {
        return false;
      }

      this.form.materials.forEach((material) => {
        sum += +material.quantityEstimate
      })

      if (((sum / this.form.materialEstimate) * 100) < 70 || sum > this.form.materialEstimate)
      {
        res = false;
      }
      

      return res;
    }
  }
  startDate = {
    required,
    dateDifference: dateDiffLessThan('endDate', 30),
    maxDateValue: maxDateValue('endDate'),
    minDateValue: function (value, model) {
      if (model.varianceCheckCourtOrder
        || model.varianceCheckPublicHealth
        || model.varianceCheckFinancialBurden
        || model.varianceCheckWorkStartedorComplete) {
        return true
      }

      const now = moment(new Date())
      now.startOf('day')
      const minDate = addWeekdays(now, 10)
      const candidate = moment(value)
      candidate.startOf('day')
      const comparison = minDate.diff(candidate)
      return comparison <= 0
    }
  }
  endDate = {
    required,
    dateDifference: dateDiffLessThan('startDate', 30),
    minDateValue: minDateValue('startDate')
  }

  asbestosPresent = { errorIfChecked }

  files = {
    platOfSurvey: {

      required: requiredUnless(function () {
        return this.form.projectType.toLowerCase() === 'asbestos' ||
          (
            Object.prototype.hasOwnProperty.call(this.form.existingFileDetails, 'platOfSurvey')
            && this.form.existingFileDetails.platOfSurvey
          )
      }),
      maxFileSize: maxFileSize(1024 * 1024 * 12)
    },
    taxSummary: {

      required: requiredUnless(function () {
        return this.form.projectType.toLowerCase() === 'asbestos' ||
          (
            Object.prototype.hasOwnProperty.call(this.form.existingFileDetails, 'taxSummary')
            && this.form.existingFileDetails.taxSummary
          )
      }),
      maxFileSize: maxFileSize(1024 * 1024 * 12)
    },
    varianceHealthRisk: {
      required: requiredIf(function () {
        if (this.form.varianceCheckPublicHealth
          || this.form.varianceCheckFinancialBurden
          || this.form.varianceCheckCourtOrder) {
          return !Object.prototype.hasOwnProperty.call(this.form.existingFileDetails, 'varianceHealthRisk')
            || !this.form.existingFileDetails.varianceHealthRisk
        }
        return false
      }),
      maxFileSize: maxFileSize(1024 * 1024 * 12)
    },
    buildingConstructionDate: {
      required: requiredIf(function () {
        if (this.form.projectType.toLowerCase() === 'demolition') {
          return !Object.prototype.hasOwnProperty.call(this.form.existingFileDetails, 'buildingConstructionDate')
            || !this.form.existingFileDetails.buildingConstructionDate
        }
        return false;
      }),
      maxFileSize: maxFileSize(1024 * 1024 * 12)
    }
  }

  contractor = {
    name: {required},
    address: {
      streetNumber: {},
      streetDirection: {},
      streetName: {required},
      streetType: {},
      suffixDir: {},
      city: {required},
      state: {required},
      zipCode: {required, minLength: minLength(5)},
      unincorporated: {}
    },
    phone: {},
    email: {}
  }
  contractorContactFirstName = {required}
  contractorContactLastName = {required}
  contractorContactPhone = {required}
  contractorContactEmail = {email, required}

  disposalSite = {
    name: {
      required: requiredIf(function () {
        return !this.form.varianceCheckWorkStartedorComplete
      })
    },
    contact: {
      required: requiredIf(function () {
        return !this.form.varianceCheckWorkStartedorComplete
      })
    },
    phone: {
      required: requiredIf(function () {
        return !this.form.varianceCheckWorkStartedorComplete
      })
    },
    email: {
      required: requiredIf(function () {
        return !this.form.varianceCheckWorkStartedorComplete
      }),
      email
    },
    address: {
      streetNumber: { numeric },
      streetDirection: {},
      streetName: { required },
      streetType: {},
      suffixDir: {},
      city: { required },
      state: { required },
      zipCode: { required, minLength: minLength(5) },
      unincorporated: {}
    }
  }
  transporter = {
    name: {
      required: requiredIf(function () {
        return !this.form.varianceCheckWorkStartedorComplete
      })
    },
    contact: {
      required: requiredIf(function () {
        return !this.form.varianceCheckWorkStartedorComplete
      })
    },
    phone: {
      required: requiredIf(function () {
        return !this.form.varianceCheckWorkStartedorComplete
      })
    },
    email: {
      required: requiredIf(function () {
        return !this.form.varianceCheckWorkStartedorComplete
      }),
      email
    },
    address: {
      streetNumber: { numeric },
      streetDirection: {},
      streetName: { required },
      streetType: {},
      suffixDir: {},
      city: { required },
      state: { required },
      zipCode: { required, minLength: minLength(5) },
      unincorporated: {}
    }
  }
  facility = {
    type: {required},
    contactName: {required},
    contactPhone: {required},
    contactEmail: {required, email},
    address: {
      streetNumber: {required},
      streetDirection: {},
      streetName: {required},
      streetType: {required},
      suffixDir: {},
      city: {required},
      state: {required},
      zipCode: {required, minLength: minLength(5)},
      unincorporated: {}
    },
    ownerAddress: {
      streetNumber: {required},
      streetDirection: {},
      streetName: {required},
      streetType: {required},
      suffixDir: {},
      city: {required},
      state: {required},
      zipCode: {required, minLength: minLength(5)},
      unincorporated: {}
    },
    contact: {required},
    phone: {required},
    email: {required, email},
    priorUse: {required},
    presentUse: {required},
    futureUse: {required},
    buildingSize: {numeric, required},
    buildingFloors: {numeric, required},
    constructionYear: {},
    buildingName: {},
    houseCount: {
      required: function () {
        if (this.form.facility.type
          && this.form.facility.type.startsWith('Residential')
          && this.form.projectType.toLowerCase() === 'demolition') {
          let houseCount = parseInt(this.form.facility.houseCount, 10)
          let garageCount = parseInt(this.form.facility.garageCount, 10)
          let shedCount = parseInt(this.form.facility.shedCount, 10)
          houseCount = Number.isNaN(houseCount) ? 0 : houseCount
          garageCount = Number.isNaN(garageCount) ? 0 : garageCount
          shedCount = Number.isNaN(shedCount) ? 0 : shedCount
          return houseCount + garageCount + shedCount !== 0
        }
        return true
      }
    },
    garageCount: {
      required: function () {
        if (this.form.facility.type
          && this.form.facility.type.startsWith('Residential')
          && this.form.projectType.toLowerCase() === 'demolition') {
          let houseCount = parseInt(this.form.facility.houseCount, 10)
          let garageCount = parseInt(this.form.facility.garageCount, 10)
          let shedCount = parseInt(this.form.facility.shedCount, 10)
          houseCount = Number.isNaN(houseCount) ? 0 : houseCount
          garageCount = Number.isNaN(garageCount) ? 0 : garageCount
          shedCount = Number.isNaN(shedCount) ? 0 : shedCount
          return houseCount + garageCount + shedCount !== 0
        }
        return true
      }
    },
    shedCount: {
      required: function () {
        if (this.form.facility.type
          && this.form.facility.type.startsWith('Residential')
          && this.form.projectType.toLowerCase() === 'demolition') {
          let houseCount = parseInt(this.form.facility.houseCount, 10)
          let garageCount = parseInt(this.form.facility.garageCount, 10)
          let shedCount = parseInt(this.form.facility.shedCount, 10)
          houseCount = Number.isNaN(houseCount) ? 0 : houseCount
          garageCount = Number.isNaN(garageCount) ? 0 : garageCount
          shedCount = Number.isNaN(shedCount) ? 0 : shedCount
          return houseCount + garageCount + shedCount !== 0
        }
        return true
      }
    }
  }

  varianceNotesPublicHealth = {
    // eslint-disable-next-line
    required: requiredIf(function (model) {
      return model.varianceCheckPublicHealth ||
        model.varianceCheckCourtOrder ||
        model.varianceCheckFinancialBurden
    })
  }
  // varianceNotesFinancialBurden = {required: requiredIf('varianceCheckFinancialBurden')}
  // varianceNotesCourtOrder = {required: requiredIf('varianceCheckCourtOrder')}
  // varianceNotesWorkStartedorComplete = {required: requiredIf('varianceCheckWorkStartedorComplete')}
  varianceNoRefundAcknowledgement = {
    required: requireCheckedIf(baseModel => baseModel.varianceCheckCourtOrder ||
      baseModel.varianceCheckFinancialBurden ||
      baseModel.varianceCheckPublicHealth ||
      false)
  }

  workHours = {
    workHoursStart: {
      required,
      maxValue: timeLessThan('workHoursEnd')
    },
    workHoursEnd: {
      required,
      minValue: timeGreaterThan('workHoursStart')
    }
  }
  partialFullDemo = {
    required: requiredIf(function () {
      return this.form.projectType.toLowerCase() === 'demolition'
    })
  }
  asbestosData = {
    // required: requiredIf(nestedModel => nestedModel.projectType && nestedModel.projectType.toLowerCase() === 'asbestos')
    surfaceAreaTotalRemoval: {
      minValue: function (value, model) {
        if (this.form.projectType.toLowerCase() === 'demolition') {
          return true
        }
        var linearTotal = parseInt(model.linearftTotalRemoval, 10)
        var surfaceTotal = parseInt(value, 10)
        if (isNaN(linearTotal)) {
          linearTotal = 0
        }
        if (isNaN(surfaceTotal)) {
          surfaceTotal = 0
        }
        return linearTotal + surfaceTotal > 0
      }
    },
    linearftTotalRemoval: {
      minValue: function (value, model) {
        if (this.form.projectType.toLowerCase() === 'demolition') {
          return true
        }
        var linearTotal = parseInt(value, 10)
        var surfaceTotal = parseInt(model.surfaceAreaTotalRemoval, 10)
        if (isNaN(linearTotal)) {
          linearTotal = 0
        }
        if (isNaN(surfaceTotal)) {
          surfaceTotal = 0
        }
        return linearTotal + surfaceTotal > 0
      }
    },
    abatementList: {
      required: requiredIf(function () {
        return this.form.projectType.toLowerCase() === 'asbestos' &&
          !this.form.asbestosData.abatementHeat &&
          !this.form.asbestosData.abatementGWR &&
          !this.form.asbestosData.abatementInfrared &&
          !this.form.asbestosData.abatementGlovebag &&
          !this.form.asbestosData.abatementSolvent &&
          !this.form.asbestosData.abatementOther
      })
    },
    asbestosRemovalMethodsOther: {
      required: requiredIf(function () {
        return this.form.projectType.toLowerCase() === 'asbestos' &&
          this.form.asbestosData.abatementOther
      })
    },
    descriptionofACM: {
      required: requiredIf(function () {
        return this.form.projectType.toLowerCase() === 'asbestos'
      })
    },

    locationofACM: {
      required: requiredIf(function () {
        return this.form.projectType.toLowerCase() === 'asbestos'
      })
    },


  }
  specialCircumstances = {required}
  name = {required}
  title = {required}
  signDate = {required}
  projectDesignerId = {
    required: requiredIf(nestedModel => nestedModel.projectType === 'asbestos'
      && nestedModel.facility
      && nestedModel.facility.type === 'School')
  }
  asbestosProjectManagerId = {
    required: requiredIf(nestedModel => nestedModel.projectType === 'asbestos'
      && nestedModel.facility
      && nestedModel.facility.type === 'School')
  }
  airSamplingProfessionalId = {
    required: requiredIf(nestedModel => nestedModel.projectType === 'asbestos'
      && nestedModel.facility
      && nestedModel.facility.type === 'School')
  }
  projectDesignerName = {
    required: requiredIf(nestedModel => nestedModel.projectType === 'asbestos'
      && nestedModel.facility
      && nestedModel.facility.type === 'School')
  }
  asbestosProjectManagerName = {
    required: requiredIf(nestedModel => nestedModel.projectType === 'asbestos'
      && nestedModel.facility
      && nestedModel.facility.type === 'School')
  }
  airSamplingProfessionalName = {
    required: requiredIf(nestedModel => nestedModel.projectType === 'asbestos'
      && nestedModel.facility
      && nestedModel.facility.type === 'School')
  }
}

export class RevisionApplicationValidation {
  // constructor () {
  //   this.facility.constructionYear = {
  //     required,
  //     between: between(1500, (new Date().getFullYear()) + 1)
  //   }
  // }
  revisionSubmitterName = {required}
  emailForRevision = {required, email}
  confirmEmail = {required, sameAs: sameAs('emailForRevision')}
  title = {required}
  signDate = {required}
  facility = {
    contactName: {required},
    contactPhone: {required},
    contactEmail: {required, email},
    address: {
      streetNumber: {required, numeric},
      streetDirection: {},
      streetName: {required},
      streetType: {required},
      suffixDir: {},
      city: {required},
      state: {required},
      zipCode: {required, minLength: minLength(5)},
      unincorporated: {}
    }
  }

  asbestosData = {
    asbestosRemovalMethodsOther: {
      required: requiredIf(baseModel => baseModel.abatementOther)
    }
  }

  // put this outside the contractor so validation can scope down into it as well as be based on the revision type
  contractorName = {
    required: required,
    error: function (value, model) {
      if (model.projectType && model.projectType.toLowerCase() === 'demolition') {
        return true
      }
      return Boolean(model.contractor.id)
    }
  }

  contractor = {
    id: {},
    name: {required},
    address: {
      streetNumber: {},
      streetDirection: {},
      streetName: {},
      streetType: {},
      suffixDir: {},
      city: {},
      state: {},
      zipCode: {minLength: minLength(5)},
      unincorporated: {}
    },
    contact: {},
    phone: {},
    email: {}
  }
  disposalSite = {
    name: {required},
    contact: {required},
    phone: {required},
    email: {required, email}
  }
  transporter = {
    name: {required},
    contact: {required},
    phone: {required},
    email: {required, email}
  }
  workStartDate = {
    required,
    minDateValue: function (value, model) {
      const now = moment(new Date())
      now.startOf('day')
      var minDateVal = now.add(1, 'days')
      if (model.omPermit == true) {
        minDateVal = now.add(1, 'days')
      }
      // const minDateVal = addWeekdays(now, 2)
      const candidate = moment(value)
      candidate.startOf('day')
      const originalStartDate = moment(model.startDate)
      originalStartDate.startOf('day')

      const nowBeforeVal = minDateVal.diff(candidate) <= 0
      const valAfterOriginal = originalStartDate.diff(candidate) <= 0
      return nowBeforeVal && valAfterOriginal
    },
    dateDifference: dateDiffLessThan('workEndDate', 30),
    maxDateValue: maxDateValue('workEndDate')
  }
  workEndDate = {
    required,
    minDateValue: minDateValue('workStartDate'),
    dateDifference: dateDiffLessThan('workStartDate', 30),
    maxDateValue: function (value, model) {
      if (model.omPermit) {
        return true
      }
      const now = moment(value)
      const expired = moment(model.permitIssueDate)
      expired.add(1, 'year')
      expired.add(3, 'day')
      return expired.diff(now) > 0
    }
  }
  workHours = {
    workHoursStart: {
      maxValue: timeLessThan('workHoursEnd')
    },
    workHoursEnd: {
      minValue: timeGreaterThan('workHoursStart')
    }
  }
  projectDesignerId = {
    required
  }
  asbestosProjectManagerId = {
    required
  }
  airSamplingProfessionalId = {
    required
  }
  projectDesignerName = {
    required
  }
  asbestosProjectManagerName = {
    required
  }
  airSamplingProfessionalName = {
    required
  }
  surfaceAreaTotalRemoval = {required}
}

export class ContractorRegistrationValidation {
  submitterName = {required}
  signDate = {required}
  contractor = {
    name: {required},
    address: {
      streetNumber: {},
      streetDirection: {},
      streetName: {required},
      streetType: {},
      suffixDir: {},
      city: {required},
      state: {required},
      zipCode: {required, minLength: minLength(5)},
      unincorporated: {}
    },
    email: {required, email},
    phone: {required, minLength: minLength(14)},
    fax: {},
    contractorIDPH: {required, minLength: minLength(8)},
    iDPHLicenseExpirationDate: {required},
    numberofYearsLicensedbytheState: {required, numeric},
    contactFirstName: {required},
    contactLastName: {required},
    contactPhone: {required, minLength: minLength(14)},
    contactEmail: {required, email},
    ownerAddress: {
      streetNumber: {},
      streetDirection: {},
      streetName: {required},
      streetType: {},
      suffixDir: {},
      city: {required},
      state: {required},
      zipCode: {required, minLength: minLength(5)},
      unincorporated: {}
    }/*
    abatement-Other: {
      required: requiredIf(baseModel => baseModel.removalAbatementOther)
    }
    */
  }

  files = {
    idphContractorLicense: {required},
    childSupportAffidavit: {required}
  }
}

export class OAndMRenewalApplicationValidation {
  submitter = {
    contractor: {},
    owner: {},
    projectDesigner: {}
  }

  contactEmail = {required}

  facility = {
    ownerAddress: {
      streetNumber: {required},
      streetDirection: {},
      streetName: {required},
      streetType: {required},
      suffixDir: {},
      city: {required},
      state: {required},
      zipCode: {required, minLength: minLength(5)},
      unincorporated: {}
    },

    contactName: {required},
    contactPhone: {required},
    contactEmail: {required},
    phone: {required},
    email: {required},
    contact: {required},
  }

  contractorContactFirstName = {required}
  contractorContactLastName = {required}
  contractorContactPhone = {required}
  contractorContactEmail = {required}
  permitStartDate = {
    required,
    minDateValue: function (value, model) {
      const now = moment(new Date())
      now.startOf('day')
      const minDateVal = now.add(2, 'days')
      // const minDateVal = addWeekdays(now, 2)
      const candidate = moment(value)
      candidate.startOf('day')
      const originalStartDate = moment(model.permitStartDate)
      originalStartDate.startOf('day')

      const nowBeforeVal = minDateVal.diff(candidate) <= 0
      const valAfterOriginal = originalStartDate.diff(candidate) <= 0
      return nowBeforeVal && valAfterOriginal
    }
  }
  submissionDate = { required }
  submitterName = {required}

  disposalSite = {
    contact: {required},
    phone: {required},
    email: {required},
    name: {required}
  }

  transporter = {
    contact: { required },
    phone: { required },
    email: { required },
    name: { required }
  }
  OMSubmittedList = {
    required: function () {
      if (
        !this.form.submitter.contractor &&
        !this.form.submitter.owner &&
        !this.form.submitter.projectDesigner
        ) {
         return false
        } else {
          return true
        }
    }
  }

  contractor = {
    name: {required}
  }

 confirmEmail = {required, sameAs: sameAs('contactEmail')}

  projectDesignerId = {
    required: requiredIf(function () {
      return (this.form &&
        this.form.facility.type == "School" && this.form.omPermit == true)
    })
  }
  asbestosProjectManagerId = {
    required: requiredIf(function () {
      return (this.form &&
        this.form.facility.type == "School" && this.form.omPermit == true)
    })
  }
  airSamplingProfessionalId = {
    required: requiredIf(function () {
      return (this.form &&
        this.form.facility.type == "School" && this.form.omPermit == true)
    })
  }
  projectDesignerName = {
    required: requiredIf(function () {
      return (this.form &&
        this.form.facility.type == "School" && this.form.omPermit == true)
    })
  }
  asbestosProjectManagerName = {
    required: requiredIf(function () {
      return (this.form &&
        this.form.facility.type == "School" && this.form.omPermit == true)
    })
  }
  airSamplingProfessionalName = {
    required: requiredIf(function () {
      return (
        this.form.facility.type == "School" && this.form.omPermit == true)
    })
  }
}

export class AddEquipmentValidations {
  equipmentType = { required }
  quantity = {
    required,
    lessThan: lessThan(100)
  }
  level2Option = {
    required: requiredIf(function () {
      if (this.form.equipmentType != 'Storage Tanks') {
        return false
      } else {
        return true
      }
    })
  }
  description = { required }
  //shouldContinue = { required }
  registerNewEquipment = {
    required: requiredIf(function () {
      if (this.form.shouldContinue == true) {
        return true
      } else {
        return false
      }
    })
  }
  usageMetric = {
    required: requiredIf(function () {
      return this.form.equipmentType != 'Processing'
    }),
    isWholeNumber: isWholeNumber()
  }
  registerControl = {
    required: requiredIf(function () {
      if (this.form.equipmentType == 'Processing' && this.form.registerNewEquipment == true) {
        return true
      } else {
        return false
      }
    })
  }
}


export class AirEmissionsValidations {
  payerEmail = { required }
  payerEmailV = {
    required,
    sameAs: sameAs('payerEmail')
  }
  iepaPermit = { required }
  naicsCode = { required }
  totalEmployees = { required }
  facilitySqFootage = { required }
  naicsOther = {
    required: requiredIf(function () {
      return this.form.naicsCode === '00000'
    })
  }
}

export class AirPaymentValidations {
  payerEmail = { required }
  payerEmailV = {
    required,
    sameAs: sameAs('payerEmail')
  }
}

export class SiteRequestValidations {
  //ownerAddress = { required }
  constructor() {

  }
  ownerAddress = {
    streetNumber: { required },
    streetDirection: {},
    streetName: { required },
    streetType: { required },
    suffixDir: {},
    city: { required },
    state: { required },
    zipCode: { required, minLength: minLength(5) },
    unincorporated: {}
  }
  siteName = {required}
  contactFirstName = { required }
  contactLastName = { required }
  contactPhone = { required, minLength: minLength(12) }
  contactEmail = { required }
  contactTitle = { required }
  confirmEmail = {
    required,
    sameAs: sameAs('contactEmail')
  }
  owner = { required }
}

export class SiteAuthenticatonValidation {
  siteNumber = { required, numeric }
}

export class OpenBurnPermitApplicationValidation {
  isMunicipality = { required }
  applicantFirstName = {
    required,
    maxLength: maxLength(50)
  }
  applicantLastName = {
    required,
    maxLength: maxLength(50)
  }
  applicantPhone = { required }

  applicantAddress = {
    streetNumber: { maxLength: maxLength(10) },
    streetName: { maxLength: maxLength(50) },
    city: { maxLength: maxLength(30) }
  }
  city = { maxLength: maxLength(30) }

  applicantEmail = {
    required,
    maxLength: maxLength(50)
  }
  confirmEmail = {
    required,
    sameAs: sameAs('applicantEmail'),
    maxLength: maxLength(50)
  }
  typeOfRequest = { required }
  siteName = {
    required,
    maxLength: maxLength(50)
  }
  siteCity = { required }
  //siteAddress = { required }
  typeOfRequestOtherDesc = {
    required: requiredIf(function () {
      if (this.form.typeOfRequest == 'Other') {
        return true
      } else {
        return false
      }
    })
  }
  files = {
    asbestosAssessmentFile: {
      required: requiredIf(function () {
        if (this.form.typeOfRequest == 'Firefighting Instruction / Research' && this.form.existingFileDetails.asbestosAssessmentFile == null && this.form.donatedBuilding == true) {
          return true
        } else {
          return false
        }
      })
    },
    statePermit: {
      required: requiredIf(function () {
        if (this.form.existingFileDetails.statePermit == null) {
          return true;
        } else {
          return false;
        }
      })
    }
  }

  burnMaterials = {
    $each: {
      name: { required },
      amount: { required },
      description: { required }
    }
  }
  otherDate = {
    required: requiredIf(function () {
      if (this.form.moreThanDay == true) {
        return true;
      } else {
        return false;
      }
    })
  }
  contactFirstName = {
    required,
    maxLength: maxLength(50)
  }
  contactLastName = {
    required,
    maxLength: maxLength(50)
  }
  contactPhone = { required }

  methodOfExtinguishment = { required }

  individualsNotifiedExplaination = {
    required: requiredIf(function () {
      if (this.form.individualsNotifiedInd) {
        return true
      } else {
        return false
      }
    })
  }

  signature = {
    required,
    maxLength: maxLength(50)
  }
  signatureDate = { required }
  signatureTitle = { maxLength: maxLength(50) }

  totalSessions = {
    required,
    lessThan: lessThan(10)
  }


  siteAddress2 = { maxLength: maxLength(100) }
  siteCity = { required, maxLength: maxLength(30) }

  crossStreets = { required }
}

export class OpenBurnRecPermitApplicationValidation {
  signature = {
    required,
    maxLength: maxLength(50)
  }
  signatureTitle = { maxLength: maxLength(50) }
  signatureDate = { required }

  address1 = { required, maxLength: maxLength(75) }
  address2 = { maxLength: maxLength(75) }
  city = { required, maxLength: maxLength(25) }
  state = { required }
  zip = { required }
  burnAddress1 = { required, maxLength: maxLength(75) }
  burnAddress2 = { maxLength: maxLength(75) }
  burnCity = { required, maxLength: maxLength(25) }
  burnState = { required }
  burnZip = { required }
  dateOfBurn = { required }
  companyName = { maxLength: maxLength(50) }
  contactEmail = { required, maxLength: maxLength(50) }
  confirmEmail = {
    required,
    sameAs: sameAs('contactEmail'),
    maxLength: maxLength(50)
  }
  contactPhone = { required }
  contactFirstName = { required, maxLength: maxLength(50) }
  contactLastName = { required, maxLength: maxLength(50) }
  localFireDepartment = { required, maxLength: maxLength(75) }
  nameOfForestPreserve = { maxLength: maxLength(75) }
  burnStartTime = { required }
  burnEndTime = { required }
}
